export const videoViewCount = (video = {}) => {
  const raw = video.view_count ?? video.views ?? 0;
  const count = Number(raw);
  return Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;
};

export const formatVideoViews = (video, { compact = false } = {}) => {
  const count = videoViewCount(video);
  if (!compact) return count.toLocaleString();
  return new Intl.NumberFormat(undefined, {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(count);
};
